import { bindRequestLogic } from './utils'
import PerTypes from '../actionTypes/vehiclePer'
import { vehiclePerAPI } from '../api'

const addVehiclePer = bindRequestLogic({
  clientFunc: vehiclePerAPI.addVehiclePer,
  type: PerTypes.ADD_VEHICLE_PER_REQUEST,
  successType: PerTypes.ADD_VEHICLE_PER_SUCCESS,
  failType: PerTypes.ADD_VEHICLE_PER_FAILED
})

const deleteVehiclePer = bindRequestLogic({
  clientFunc: vehiclePerAPI.deleteVehiclePer,
  type: PerTypes.DELETE_VEHICLE_PER_REQUEST,
  successType: PerTypes.DELETE_VEHICLE_PER_SUCCESS,
  failType: PerTypes.DELETE_VEHICLE_PER_FAILED
})

export default [addVehiclePer, deleteVehiclePer]
